export default __webpack_public_path__ + "static/media/KBM04494.063ae991.webp";